/** A fan's recent searches per network, kept in this browser only. */
export const RECENT_SEARCH_LIMIT = 5;

function storageKey(organizationId: number | string): string {
  return `tm_recent_search_${organizationId}`;
}

export function readRecentSearches(organizationId: number | string): string[] {
  if (!organizationId) {
    return [];
  }
  try {
    const list = JSON.parse(localStorage.getItem(storageKey(organizationId)) || '[]');
    return Array.isArray(list) ? list.filter((term) => typeof term === 'string').slice(0, RECENT_SEARCH_LIMIT) : [];
  } catch {
    return [];
  }
}

/** Puts the term first, drops duplicates (any case) and keeps the newest five. */
export function addRecentSearch(organizationId: number | string, term: string): string[] {
  const clean = (term || '').trim();
  if (!organizationId || !clean) {
    return readRecentSearches(organizationId);
  }
  const list = [clean, ...readRecentSearches(organizationId)
    .filter((item) => item.toLowerCase() !== clean.toLowerCase())].slice(0, RECENT_SEARCH_LIMIT);
  try {
    localStorage.setItem(storageKey(organizationId), JSON.stringify(list));
  } catch {
    // Storage blocked (private mode); the list simply is not remembered.
  }
  return list;
}
